var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HomeWidgetSmall',{attrs:{"actionButtonHandler":_vm.navigateToInvestigative,"hasError":_vm.hasError,"isLoading":_vm.isLoading,"metric":_vm.totalCount,"widgetType":_vm.userGroupSuggestions}})
}
var staticRenderFns = []

export { render, staticRenderFns }